import React, { useState } from "react";
import { useForm } from "react-hook-form";

const DEMO_OPTIONS = [
  { id: "oms", name: "oms", label: "Order Management System (OMS)" },
  { id: "ems", name: "ems", label: "Execution Management System (EMS)" },
  { id: "pms", name: "pms", label: "Portfolio Management System (PMS)" },
  { id: "capital_raising", name: "capital_raising", label: "Capital Raising (IMS)" },
  { id: "itiaas", name: "itiaas", label: "Institutional Trading Infrastructure-as-a-Service (ITIaaS)" },
  { id: "tpaas", name: "tpaas", label: "Trading Platform-as-a-Service (TPaaS)" },
  { id: "cmmp", name: "cmmp", label: "Collateral & Margin Management Platform (CMMP)" },
  { id: "auro_liquid", name: "auro_liquid", label: "DeFi Cross-Chain Liquidity Aggregator (Auro Liquid)" },
  { id: "auracle", name: "auracle", label: "Oracle (Auracle)" },
  { id: "staking", name: "staking", label: "Staking" },
];

const RequestDemo = () => {
  const { handleSubmit } = useForm();
  const [loading, setLoading] = useState(false);

  const [registration, setRegistration] = useState({
    id: "",
    fist_name: "",
    last_name: "",
    company: "",
    title: "",
    website: "",
    country: "",
    phone: "",
    email: "",
    w3review: "",
  });
  const [interests, setInterests] = useState({});
  const [honeypot, setHoneypot] = useState("");

  const resetForm = () => {
    setRegistration({
      id: "",
      fist_name: "",
      last_name: "",
      company: "",
      title: "",
      website: "",
      country: "",
      phone: "",
      email: "",
      w3review: "",
    });
    setInterests({});
    setHoneypot("");
  };

  const handleInputs = (e) => {
    const { name, value } = e.target;
    setRegistration({ ...registration, [name]: value });
  };

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    setInterests((prev) => ({ ...prev, [name]: checked }));
  };

  const onSubmit = async () => {
    // Hidden field bots fill in. Never call the API, so no email is sent.
    if (honeypot.trim() !== "") {
      window.alert("Form has been submitted sucessfully");
      resetForm();
      return;
    }

    const {
      key: id = new Date().toString(),
      fist_name,
      last_name,
      company,
      title,
      website,
      country,
      phone,
      email,
      w3review,
    } = registration;

    const userData = {
      id,
      fist_name,
      last_name,
      company,
      title,
      website,
      country,
      phone,
      email,
      w3review,
      website_url: "",
      ...interests,
    };
    await PostData(userData);
  };

  const PostData = async (data) => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://25gs1qsys1.execute-api.ap-south-1.amazonaws.com/prod/items",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (response.ok) {
        window.alert("Form has been submitted sucessfully", data);
        resetForm();
      } else {
        const errorData = await response.json();
        window.alert(`Error: ${errorData.error}`);
      }
    } catch (error) {
      window.alert("Error submitting form:", error);
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="top-box">
        <div className="section">
          <section className="wrapper-demo">
            <div className="form-container">
              <form
                className="form"
                method="POST"
                onSubmit={handleSubmit(onSubmit)}
              >
                <h1 className="request-demo-heading">Request Demo</h1>

                <div className="hp-field" aria-hidden="true">
                  <label htmlFor="website_url">Website URL</label>
                  <input
                    type="text"
                    id="website_url"
                    name="website_url"
                    tabIndex={-1}
                    autoComplete="off"
                    value={honeypot}
                    onChange={(e) => setHoneypot(e.target.value)}
                  />
                </div>

                <div className="two-inputs">
                  <div className="solve-margin">
                    <label htmlFor="fist_name">First name *</label>
                    <input
                      type="text"
                      id="fist_name"
                      name="fist_name"
                      value={registration.fist_name}
                      onChange={handleInputs}
                      required
                    />
                  </div>
                  <div className="sec-div-margin">
                    <label htmlFor="last_name">Last name *</label>
                    <input
                      type="text"
                      id="last_name"
                      name="last_name"
                      value={registration.last_name}
                      onChange={handleInputs}
                      required
                    />
                  </div>
                </div>

                <div className="two-inputs">
                  <div className="solve-margin">
                    <label htmlFor="company">Company *</label>
                    <input
                      className="full-input"
                      type="text"
                      id="company"
                      name="company"
                      value={registration.company}
                      onChange={handleInputs}
                      required
                    />
                  </div>
                  <div className="sec-div-margin">
                    <label htmlFor="title">Title</label>
                    <input
                      className="full-input"
                      type="text"
                      id="title"
                      name="title"
                      value={registration.title}
                      onChange={handleInputs}
                    />
                  </div>
                </div>

                <div className="two-inputs">
                  <div className="solve-margin">
                    <label htmlFor="website">Website</label>
                    <input
                      className="full-input"
                      type="text"
                      id="website"
                      name="website"
                      value={registration.website}
                      onChange={handleInputs}
                    />
                  </div>
                  <div className="sec-div-margin">
                    <label htmlFor="country">Country *</label>
                    <input
                      className="full-input"
                      type="text"
                      id="country"
                      name="country"
                      value={registration.country}
                      onChange={handleInputs}
                      required
                    />
                  </div>
                </div>

                <div className="two-inputs">
                  <div className="solve-margin">
                    <label htmlFor="phone">Phone *</label>
                    <input
                      type="text"
                      id="phone"
                      name="phone"
                      value={registration.phone}
                      onChange={handleInputs}
                      required
                    />
                  </div>
                  <div className="sec-div-margin">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="text"
                      id="email"
                      name="email"
                      value={registration.email}
                      onChange={handleInputs}
                      required
                    />
                  </div>
                </div>

                <div className="send-msg-flex">
                  <div className="checkout-form">
                    <div className="checkbox-container browsers">
                      <label className="checkbox-heading" htmlFor="interest">
                        What would you like to include in your demo?
                      </label>
                      <div className="checlbox-inner-container">
                        {DEMO_OPTIONS.map((option) => (
                          <div
                            key={option.id}
                            className="checkbox-inner-container"
                          >
                            <input
                              className="checkbox"
                              type="checkbox"
                              id={option.id}
                              name={option.name}
                              checked={!!interests[option.name]}
                              onChange={handleCheckbox}
                            />
                            <label
                              className="checkbox-label"
                              htmlFor={option.id}
                            >
                              {option.label}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="send-msg">
                    <section>
                      <div className="message-container">
                        <label htmlFor="message">Send us a message</label>
                        <textarea
                          className="text-area-input"
                          id="w3review"
                          name="w3review"
                          value={registration.w3review}
                          onChange={handleInputs}
                          rows="6"
                          cols="50"
                          placeholder="Type your message here..."
                        />
                      </div>
                    </section>
                  </div>
                </div>

                <div className="submit-req">
                  <button type="submit" style={{ cursor: "pointer" }}>
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default RequestDemo;
